<template>
  <div>
    <br />
    <div class="row">
      <div class="col-3">
        <label for=""> Fournisseur </label>
        <select
          class="form-select"
          v-model="payment.supplier_reference"
          @change="getSupplierPurchasesUnpaid(payment.supplier_reference)"
        >
          <option value="" default></option>
          <option
            v-for="(supplier, index) in suppliers"
            :key="index++"
            :value="supplier.reference"
          >
            <div class="row justify-content-between">
              <span class="col-auto">
                {{ supplier.fullName }}
              </span>
              <span class="col-auto">
                {{ supplier.society }}
              </span>
            </div>
          </option>
        </select>
        <small
          v-if="payment.supplier_reference && totalUnpaid > 0"
          class="text-danger fw-bold"
        >
          Total impayé: {{ parseFloat(totalUnpaid).toFixed(2) }} DH
        </small>
      </div>

      <div class="col-7">
        <label for=""> Factures impayées </label>
        <select class="form-select" v-model="payment.purchase_reference">
          <option value="" default></option>
          <option
            v-for="(purchase, index) in purchases"
            :key="index++"
            :value="purchase.reference"
            :style="{ color: 'red' }"
          >
            <div class="row justify-content-between">
              Nº {{ purchase.reference }}, Facturait le
              <span class="col-auto text-success">
                {{ purchase.date }}
              </span>
              Payer
              <span :style="{ color: 'green' }" class="col-auto text-success">
                {{ purchase.amountPaid }}
              </span>
              à partir de
              <span class="col-auto">
                {{ purchase.totalPriceTTC }}
              </span>
              reste
              <span class="col-auto text-danger">
                {{ purchase.amountUnpaid }}
              </span>
            </div>
          </option>
        </select>
      </div>
      <div class="col-2">
        <label for="">Montant</label>
        <div class="input-group">
          <input type="text" v-model="payment.amount" class="form-control" />
          <button
            v-if="payment.purchase_reference"
            type="button"
            class="btn btn-outline-primary"
            @click="fillAmount"
            title="Remplir avec le montant impayé"
          >
            <i class="bi bi-arrow-down-circle"></i> Remplir
          </button>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-3">
        <label for="">Date</label>
        <input type="date" v-model="payment.date" class="form-control" />
      </div>
      <div class="col-3">
        <label for="">Mode de paiement</label>
        <select v-model="payment.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Effet">Effet</option>
        </select>
      </div>

      <div class="col-3">
        <label for="">Numéro de chèque</label>
        <input type="text" v-model="payment.checkNumber" class="form-control" />
      </div>

      <div class="col-3">
        <label for="">Numéro de virement bancaire</label>
        <input
          type="text"
          v-model="payment.bankTransferNumber"
          class="form-control"
        />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <label for="">Remarques</label>
        <textarea class="form-control" cols="30" rows="3"></textarea>
      </div>
    </div>
    <br />
    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(payment)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      payment: {
        supplier_reference: "",
        purchase_reference: "",
        amount: "",
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        paymentMethod: "",
        checkNumber: "",
        bankTransferNumber: "",
      },
    };
  },
  computed: {
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
    ...mapGetters("purchase", {
      purchases: "getPurchases",
      totalUnpaid: "getPurchasesTotalUnpaid",
    }),
    selectedPurchase() {
      if (
        !this.payment.purchase_reference ||
        !this.purchases ||
        !this.purchases.length
      ) {
        return null;
      }
      const purchase = this.purchases.find(
        (p) => p.reference === this.payment.purchase_reference
      );
      return purchase || null;
    },
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("payment/storePaymentSupplier", data);
    },
    async getSupplierPurchasesUnpaid(supplier_reference) {
      if (!supplier_reference) {
        this.payment.purchase_reference = "";
        this.payment.amount = "";
        return;
      }
      // Loading is handled by the Vuex action using $api.fetch
      await this.$store.dispatch(
        "purchase/getSupplierPurchasesUnpaid",
        supplier_reference
      );
    },
    fillAmount() {
      console.log("fillAmount called");
      console.log(
        "payment.purchase_reference:",
        this.payment.purchase_reference
      );
      console.log("purchases:", this.purchases);
      console.log("selectedPurchase:", this.selectedPurchase);

      if (!this.payment.purchase_reference) {
        console.log("No purchase reference selected");
        return;
      }

      // Use the computed property if available, otherwise find it
      let purchase = this.selectedPurchase;

      if (!purchase) {
        if (!this.purchases || !this.purchases.length) {
          console.log("No purchases loaded");
          return;
        }

        purchase = this.purchases.find(
          (p) => p.reference === this.payment.purchase_reference
        );
      }

      if (!purchase) {
        console.log("Purchase not found");
        return;
      }

      console.log("Found purchase:", purchase);
      console.log("purchase.amountUnpaid:", purchase.amountUnpaid);

      // Handle amountUnpaid - it might be a number, string, or formatted string
      let amountUnpaid = purchase.amountUnpaid;

      if (
        amountUnpaid === null ||
        amountUnpaid === undefined ||
        amountUnpaid === ""
      ) {
        console.log("amountUnpaid is null/undefined/empty");
        return;
      }

      // Convert to string if it's a number
      if (typeof amountUnpaid === "number") {
        amountUnpaid = amountUnpaid.toString();
      }

      // Remove any formatting (spaces, commas) if it's a string
      if (typeof amountUnpaid === "string") {
        amountUnpaid = amountUnpaid.replace(/\s/g, "").replace(/,/g, "").trim();
      }

      const amount = parseFloat(amountUnpaid);
      console.log("Parsed amount:", amount);

      if (isNaN(amount)) {
        console.log("Invalid amount - NaN");
        return;
      }

      if (amount <= 0) {
        console.log("Amount is not positive:", amount);
        return;
      }

      // Set the amount with 2 decimal places
      this.payment.amount = amount.toFixed(2);
      console.log("Amount successfully set to:", this.payment.amount);
    },
  },
  beforeMount() {
    this.$store.dispatch("supplier/getAll");
  },
};
</script>
